import React from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import ClipboardHighlight from "./ClipboardHighlight";
import ClipboardPara from "./ClipboardPara";
import ClipboardText from "./ClipboardText";
import ClipboardTextarea from "./ClipboardTextarea";

const FormClipboardContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs title="Clipboard" pageTitle="Clipboard" parent="Form Widgets" />
      <Row>
        <ClipboardText />
        <ClipboardTextarea />
        <ClipboardPara />
        <ClipboardHighlight />
      </Row>
    </Container>
  );
};
export default FormClipboardContain;
